export const DEM_MANUFACTURER_URL_PARAM = "manufacturer"
export const DEM_MANUFACTURER_API_KEY = "device_manufacturers"
export const DEM_MANUFACTURER_REF_KEY = "deviceManufacturers"

export const DEM_MODEL_URL_PARAM = "model_reference"

export const DEM_VOLTAGE_URL_PARAM = "voltage"
export const DEM_VOLTAGE_API_KEY = "device_voltages"
export const DEM_VOLTAGE_REF_KEY = "deviceVoltages"

export const DEM_STATUS_URL_PARAM = "compliance_status"
export const DEM_STATUS_API_KEY = "compliance_status"
export const DEM_STATUS_REF_KEY = "compliance_status"

export const DEM_PHASE_URL_PARAM = "phase"
export const DEM_PHASE_API_KEY = "device_phases"
export const DEM_PHASE_REF_KEY = "phases"

// Raw API input type
type TDemandRefInput = {
    device_manufacturers: string[]
    device_models: string[]
    device_voltages: number | string[]
    device_phases: number | string[]
}

// Mapper Output type
export type TDemandRefOutput = {
    deviceManufacturers: string[]
    deviceVoltages: number | string[]
    phases: number | string[]
}

// Overall output type
type TDemandFilterReferenceMapper = {
    map: (response: unknown) => TDemandRefOutput
}
export const demandFilterReferenceMapper: TDemandFilterReferenceMapper = {
    /**
     * Maps API response into UI data model and replaces missing arrays. Appends
     * in static option jurisdiction. This is for demand search reference
     * data
     */
    map: (response: unknown) => ({
        [DEM_MANUFACTURER_REF_KEY]:
            (response as TDemandRefInput)[DEM_MANUFACTURER_API_KEY] || [],
        [DEM_VOLTAGE_REF_KEY]:
            (response as TDemandRefInput)[DEM_VOLTAGE_API_KEY] || [],
        [DEM_PHASE_REF_KEY]:
            (response as TDemandRefInput)[DEM_PHASE_API_KEY] || [],
    }),
}
